import React from 'react'
import { createPortal } from 'react-dom'
import Datetime from 'react-datetime'
import Select, { components } from 'react-select'
import { Modal } from 'react-bootstrap'
import { KTSVG } from '_metronic/helpers'
import moment from 'moment'

interface Props {
  formType: 'add' | 'edit'
  isSubmitting: boolean
  isOpen: boolean
  options: any[]
  formState: any
  onChangeFormState: (name: string, value: any) => void
  handleClose: () => void
  onSubmit: () => void
}

const MachineAssigning: React.FC<Props> = ({
  formType,
  isSubmitting,
  isOpen,
  options,
  formState,
  onChangeFormState,
  handleClose,
  onSubmit,
}) => {
  const modalsRoot = document.getElementById('root-modals') || document.body

  const InstallationTypes = [
    'Pure Drive (ปั้นจั่น)',
    'Pure Drive (PD)',
    'Green Pile',
    'Prebored + Drive',
    'Auger + Drive',
    'FC-PTG',
    'JIP',
  ]
  const installationTypeOptions = InstallationTypes.map(type => ({ label: type, value: type }))

  return createPortal(
    (
      <Modal
        id='kt_modal_asset_resourece_authorization_form'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-900px'
        show={isOpen}
        onHide={handleClose}
        backdrop={isSubmitting ? 'static' : true}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h2>
              {formType === 'add' ? 'เพิ่มเครื่องจักรในโครงการ' : 'แก้ไขเครื่องจักรในโครงการ'}
            </h2>
            {/* begin::Close */}
            <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={handleClose}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
            </div>
            {/* end::Close */}
          </div>

          <div className='modal-body py-lg-10 px-lg-10 min-h-100px'>
            <div className='mb-5'>
              <label htmlFor='type' className='form-label'>
                เครื่องจักร <span className='required'></span>
              </label>
              <Select
                isDisabled={isSubmitting}
                id='type'
                options={options}
                value={options.find(o => o.value === formState.machineId) ?? null}
                onChange={(selectedOption: any) => {
                  onChangeFormState('machineId', selectedOption?.value)
                }}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    minHeight: 0,
                    fontSize: '0.95rem',
                    border: '1px solid #e1e3ea',
                  }),
                }}
                components={{
                  SingleValue: (props: any) => {
                    return (
                      <components.SingleValue {...props} className='d-flex flex-row gap-2'>
                        <div className='text-nowrap'>{props.data.label}</div>
                        {props.data?.projectMachine && (
                          <div className='text-danger'>
                            (โครงการที่ใช้: {props?.data.projectMachine?.division})
                          </div>
                        )}
                      </components.SingleValue>
                    )
                  },
                  Option: (props: any) => {
                    return (
                      <components.Option {...props} className='d-flex flex-row gap-2'>
                        <div className='text-nowrap'>{props.data.label}</div>
                        {props.data?.projectMachine && (
                          <div className='text-danger'>
                            (โครงการที่ใช้: {props?.data.projectMachine?.division})
                          </div>
                        )}
                      </components.Option>
                    )
                  },
                }}
              />
            </div>

            <div className='mb-5'>
              <label htmlFor='pillingType' className='form-label'>
                ระบบติดตั้ง
              </label>
              <Select
                isDisabled={isSubmitting}
                id='pillingType'
                options={installationTypeOptions}
                value={installationTypeOptions.find(o => o.value === formState.pillingType) ?? null}
                onChange={(selectedOption: any) => {
                  onChangeFormState('pillingType', selectedOption?.value)
                }}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    minHeight: 0,
                    fontSize: '0.95rem',
                    border: '1px solid #e1e3ea',
                  }),
                }}
              />
              {/* <input
                name='pillingType'
                type='text'
                className='form-control form-control-sm'
                value={formState.pillingType}
                onChange={(e: any) => onChangeFormState('pillingType', e.target.value)}
              /> */}
            </div>

            <div className='mb-5'>
              <label htmlFor='type' className='form-label'>
                ผู้รับเหมา
              </label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={formState.contractor}
                onChange={(e: any) => onChangeFormState('contractor', e.target.value)}
              />
            </div>

            <div className='mb-5'>
              <label htmlFor='type' className='form-label'>
                วันที่เข้างาน <span className='required'></span>
              </label>

              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                renderInput={props => {
                  return <input {...props} autoComplete='off' />
                }}
                closeOnClickOutside
                className='filter-date-input w-100 z-4'
                value={formState.arrivedAt ?? null}
                onChange={(val: any) => onChangeFormState('arrivedAt', moment(val).toISOString())}
              />
            </div>

            <div className='mb-5'>
              <label htmlFor='type' className='form-label'>
                วันที่เริ่มทำงาน
              </label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                renderInput={props => {
                  return <input {...props} autoComplete='off' />
                }}
                closeOnClickOutside
                className='filter-date-input w-100 z-4'
                value={formState.actionAt ?? null}
                onChange={(val: any) => onChangeFormState('actionAt', moment(val).toISOString())}
              />
            </div>

            <div className='mb-5'>
              <label htmlFor='type' className='form-label'>
                วันที่ออกจากงาน
              </label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                renderInput={props => {
                  return <input {...props} autoComplete='off' />
                }}
                closeOnClickOutside
                className='filter-date-input w-100 z-4'
                value={formState.departedAt ?? null}
                onChange={(val: any) => onChangeFormState('departedAt', moment(val).toISOString())}
              />
            </div>

            <div className='mb-5'>
              <label htmlFor='type' className='form-label'>
                ลิงค์วีดีทัศน์ <span className='text-muted'>(ถ้ามี)</span>
              </label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={formState.externalStreamingEndpoint}
                onChange={(e: any) =>
                  onChangeFormState('externalStreamingEndpoint', e.target.value)
                }
              />
            </div>
          </div>

          <div className='modal-footer'>
            <button className='btn btn-light fw-bold' onClick={handleClose} disabled={isSubmitting}>
              ยกเลิก
            </button>
            <button className='btn btn-primary fw-bold' onClick={onSubmit} disabled={isSubmitting}>
              บันทึก
            </button>
          </div>
        </div>
      </Modal>
    ) as any,
    modalsRoot
  )
}

export default MachineAssigning
